import React, { useContext } from 'react';
import HeaderContext, { HeaderContextInterface } from '../../HeaderContext';
import { Home } from './Home';
import { Dashboard } from './Dashboard';
import { MySurveys } from './MySurveys';
import { Pricing } from './Pricing';
import { TeamMenu } from './TeamMenu';
import { ExploreMenu } from '../explore-menu';

const BaseMenu = ({
  experiment,
}: {
  experiment: Record<string, any> | undefined;
}): JSX.Element => {
  const headerContext = useContext<HeaderContextInterface>(HeaderContext);
  // Global Header experiment
  // https://momentiveai.atlassian.net/browse/HOME-737
  const lihpTreatment = experiment?.lihpHeader?.treatment;
  const { homePageEnabled, hasLIHPFeature, hasSeenLIHPWelcomeModal } =
    headerContext?.user ?? {};
  const hasLIHPTreatment = [
    'has_lihp',
    'lihp_paid_individuals_treatment',
    'lihp_teams_treatment',
    'lihp_sme_treatment',
  ].includes(lihpTreatment);

  // Global Header experiment
  // https://momentiveai.atlassian.net/browse/WEBEXP-762
  // https://admin.surveymonkey.com/experiments/surveymonkey/2356
  const exploreTabTreatment = experiment?.exploreTab?.treatment;
  const hasExploreTab = exploreTabTreatment === 'explore_experiment_enabled';

  return (
    <>
      {homePageEnabled !== false &&
      (hasLIHPFeature || hasSeenLIHPWelcomeModal || hasLIHPTreatment) ? (
        <Home key="menu-home" />
      ) : (
        <>
          <Dashboard key="menu-dashboard" />
          <MySurveys key="menu-surveys" />
        </>
      )}
      <TeamMenu key="menu-team" />
      {hasExploreTab && <ExploreMenu key="menu-explore" />}
      <Pricing key="menu-pricing" />
    </>
  );
};

export default BaseMenu;
